import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Rocket } from "lucide-react";
import { api } from "@/lib/api";
import { useTx } from "@/components/PaymentPanel";

export function LaunchAnswers() {
  const tx = useTx();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/launch-plan").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const stages = d.stages.map((s) => ({ ...s, answered: s.missions.filter((m) => m.answer) })).filter((s) => s.answered.length);
  return (
    <section className="sb-card p-5" data-testid="biz-launch-answers">
      <div className="flex items-center justify-between gap-2">
        <div className="sb-eyebrow flex items-center gap-2"><Rocket className="h-4 w-4 text-[#1DB99A]" />{tx("My Launch Plan answers", "Mes réponses du plan de lancement")}</div>
        <Link to="/launch" className="text-xs font-semibold text-[#179B80]" data-testid="biz-launch-answers-edit">{tx("Edit in Launch Plan", "Modifier dans le plan")}</Link>
      </div>
      {!stages.length && <p className="text-sm text-[#5C6B73] mt-3" data-testid="biz-launch-answers-empty">{tx("Your answers to the Launch Plan missions will appear here.", "Vos réponses aux missions du plan apparaîtront ici.")}</p>}
      {stages.map((s) => (
        <div key={s.key} className="mt-4" data-testid={`biz-launch-stage-${s.n}`}>
          <div className="text-sm font-extrabold font-display">{s.n}. {s.title}</div>
          <div className="divide-y divide-[#EADEC9]">
            {s.answered.map((m) => (
              <div key={m.id} className="py-2.5" data-testid={`biz-launch-answer-${m.id}`}>
                <div className="text-xs font-bold text-[#5C6B73]">{m.title}</div>
                <p className="text-sm mt-1 whitespace-pre-wrap">{m.answer}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
